<template>
  <svg
    class="play-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 78.02 71.75"
  >
    <path id="svzfb" d="M1.66,20.24C-5.62,36.65,12.7,67.17,24.39,71s39.41-8.4,47.28-22.31,9.73-43.44-2-47.3S10.25.86,1.66,20.24Z"/>
    <polygon fill="#fff" id="svzfb" points="44.6 34.65 35.55 29.43 35.55 39.87 44.6 34.65"/>
  </svg>
</template>

<script>
export default {}
</script>

<style lang="scss">
.play-icon {
  @include easeOut;

  width: 65px;
  height: 58px;
  fill: #ff0022;

  #svzfa {
    @include easeOut;

    fill: #ff0022;
  }

  &:hover {
    transform: scale(1.15);
    fill: #d90022;

    #svzfa {
      fill: #d90022;
    }
  }
}

.banner__play {
  &:hover {
    .play-icon {
      transform: scale(1.15);
      fill: #d90022;

      #svzfa {
        fill: #d90022;
      }
    }
  }
}

@include media-min($tablet-width) {
  .play-icon {
    width: 87px;
    height: 78px;
  }
}

@include media-min($desktop-width) {
  .play-icon {
    width: 157px;
    height: 142px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_SVG/PlayVideoIcon.vue